import { HOST_NAMES } from '../utils/appConstants';
const {
  DEV_HOST,
  LOCAL_HOST,
  BLUE_HOST
} = HOST_NAMES;
export function setLocalStorage(key, object) {
  let value = JSON.stringify(object);
  localStorage.setItem(key, value);
}
export function getLocalStorage(key) {
  let retValue;
  let stringValue = localStorage.getItem(key);
  if (stringValue !== null && stringValue !== undefined) {
    retValue = stringValue;
  }
  return retValue;
}
export function getClientId(hostName) {
  let clientId = config.PROD_CLIENT_ID;
  if (hostName.includes(DEV_HOST)) {
    clientId = config.DEV_CLIENT_ID;
  } else if (hostName.includes(LOCAL_HOST)) {
    clientId = config.LOCALHOST_CLIENT_ID;
  } else if (hostName.includes(BLUE_HOST)) {
    clientId = config.BLUE_CLIENT_ID;
  }
  return clientId;
}
export function getUniqueObject(data) {
  let uniqueObject = [];
  if (data && data.length > 0) {
    uniqueObject = data.filter((v, i, a) => a.findIndex(v2 => v2.id === v.id) === i);
  }
  return uniqueObject;
}
export function getApiPrefixURL() {
  // return 'http://localhost:443'; // --> for local development
  return `https://${window.location.host}`; // --> for aws servers
}